import { render, staticRenderFns } from "./GiftCommentsModal.vue?vue&type=template&id=1a3e58c6&"
import script from "./GiftCommentsModal.vue?vue&type=script&lang=js&"
export * from "./GiftCommentsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports